import { useVerifiedOffer, useVerifiedUnipalOffer } from '../state';

import shallow from 'zustand/shallow';

/*
  this hook is used to get Unipal offer params.
*/

export const useUnipalOfferParams = () => {
  const verifiedOffer = useVerifiedOffer(s => s.verifiedOffer, shallow);
  const [verifiedUnipalOffer] = useVerifiedUnipalOffer(
    s => [s.verifiedUnipalOffer],
    shallow
  );
  const getUnipalOfferParams = () =>
    verifiedOffer?.isUnipalOfferApplied
      ? {
          unipalStudentId: verifiedUnipalOffer?.unipalStudentId,
          unipalSessionId: verifiedUnipalOffer?.unipalSessionId,
          unipalPhoneNumber: verifiedUnipalOffer?.unipalPhoneNumber,
          unipalCode: verifiedUnipalOffer?.unipalCode,
        }
      : {};

  return { getUnipalOfferParams };
};
